import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { SummaryItem } from '../../../../services/result-data/result-data.service';
import { FormatNumbersHtmlPipe } from '../../../../pipes/format-numbers-html.pipe';

@Component({
  selector: 'app-summary',
  imports: [MatIconModule, FormatNumbersHtmlPipe],
  templateUrl: './summary.component.html',
  styleUrl: './summary.component.scss',
})
export class SummaryComponent {
  @Input() items!: SummaryItem[];
}
